var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "231",
        viewBox: "0 0 353 231",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                x1: "0%",
                y1: "50.005%",
                x2: "100.011%",
                y2: "50.005%",
                id: "3v2tw9ey7a",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#FFF", offset: "1%" } }),
              _c("stop", { attrs: { "stop-color": "#FAFAFA", offset: "31%" } }),
              _c("stop", { attrs: { "stop-color": "#ECECED", offset: "66%" } }),
              _c("stop", {
                attrs: { "stop-color": "#D8D8D9", offset: "100%" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", {
          attrs: {
            d: "M38.42 213.71c1.85-1.67 4.2-4 6.82-4.88 1.92-.62 4.22-.47 6.31-.84 4-.71 7.94-1.34 11.95-1.87 35-4.58\n       71.21-2.21 105.31 5.35l34-8.77s6.23-4 30.95-3.25c14.1.43 28.26 3.61 41.81 6.58a786.074 786.074 0 0141\n       10.14c4.94 1.36 15.9 4 11.24 9.9-1.31 1.66-3.44 2.47-5.78 2.92-8.31\n       1.6-17.41.2-25.56-1.27-16-2.89-32.2-5.32-48.48-7.06-12.3-1.31-24.69-2.25-37.1-2.41-5.87-.08-11.75\n       0-17.6.4-2.65.17-5.29.4-7.91.71-1.76.21-5.74 1.48-7.37 1.09-14-3.28-29.47-3.67-43.88-3.56a340.85 340.85 0\n       00-53 4.75c-5.29.88-10.81 1.72-16 2.9-5.33 1.22-11 1.43-16.2 2.86-3.92 1.07-8.89 2.42-13\n       1.85-4.51-.62-5.52-3.72-4.16-7a26 26 0 016.63-8.57l.02.03z",
            fill: "url(#3v2tw9ey7a)",
            transform: "translate(0.000000, 1.000000)",
          },
        }),
        _c("path", {
          attrs: {
            d: "M282.74 184.23a97.03 97.03 0 10-194.06 0v.94h194.01c0-.32.05-.63.05-.94z",
            fill: "#D8D8D9",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M.75\n       100.1h36.33v85.06h18.49m211.83-80.27V83.74h55.47v66.82h28.88m-351 50.71h51.79m234.68 2.49h64.53",
          },
        }),
        _c("path", {
          attrs: {
            d: "M207.57 60.01c7.21.62 14.45 1.16 21.69 1.27 1.94 0 4.66.4 6.53-.32 1.19-.46 1.81-1.71 2.35-2.81a47.43\n       47.43 0 014.55-7.7 13 13 0 002.63-4.58c.15-.67.18-1.36.31-2 .171-.802.43-1.584.77-2.33.85-2 2.08-5.73\n       3.35-7.46.48-.65.48-.63 1.28-.58 2.29.15 3.71.94 5.08 1 1.05 0 1.4-.73 2.07.09a3.77 3.77 0 01.39 3l-1\n       7.34c-.34 2.38-1.51 4.29-2.14 6.61-.73 2.66-1.48 5.32-2.29 8-1.19 3.89-2.31 8.1-4.38 11.64-4.3 7.37-15.79\n       8.61-15.79 8.61l-9.5-.58-15.9-19.2z",
            fill: "#ED1D24",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M240.51 77.56l-8.34-16.17c-1 0-2-.1-2.91-.11h-1.21l9 17.51a29.36 29.36 0\n       003.46-1.23zm-25.74-16.98c-2.4-.173-4.8-.363-7.2-.57l15.83 19 .91.06-9.54-18.49zm15.35\n       18.87l-9.53-18.5a315.08 315.08 0 01-4.06-.25l9.53 18.5 4.06.25zm14.84-4.39l-7.83-15.19a3.14 3.14 0 01-1.35\n       1.08 7 7 0 01-1.94.39l8 15.59a20.07 20.07 0 003.12-1.87zm3.73-3.99l-8.62-16.62c-.68 1.21-1.32 2.44-1.93\n       3.7l-.1.21 8.12 15.75a13 13 0\n       002.53-3.04zm8.8-26.27v-.34l-5.47-10.62c-.28.09-1.11-.44-1.37-.29-.69.42-.5-.18-1 .46-.07.1-.29 2.1-.37\n       2.2l6.73 13.05a19.89 19.89 0 001.48-4.46zm-2.14 6.65l.05-.18-7-13.59a28 28 0 00-2 3.76l7.61 14.76\n       1.34-4.75zm-4.11 13.75l-8-15.55-.55.8c-.6.81-1.15 1.65-1.68 2.5l8.49 16.5a37.22 37.22 0\n       001.74-4.25zm1.82-5.84l.33-1.12-7.7-14.88c0 .15-.09.3-.12.45-.13.67-.16 1.36-.31 2a7.76 7.76 0 01-1.09\n       2.43l7.7 14.93c.43-1.26.82-2.55 1.19-3.81zM232.9 79.62a25.71 25.71 0 002.68-.49l-9.25-17.94c-1.34\n       0-2.68-.09-4-.15l9.54 18.52 1.03.06zm25.64-42.17a3.77 3.77 0 00-.39-3 3.78 3.78 0 00-2.91-.95h-1.63l4.29\n       8.33.64-4.38z",
          },
        }),
        _c("path", {
          attrs: {
            d: "M248.69 71.01c.29-.5.56-1 .82-1.54l-8.53-16.55c-.31.5-.62 1-.91 1.52l8.62 16.63v-.06zm-2.54\n       3.08l-8.12-15.75a9 9 0 01-.9 1.53l7.83 15.19c.41-.3.81-.61 1.19-.97zm-4.27 2.84l-8-15.59a16.6 16.6 0 01-1.67\n       0l8.34 16.17c.41-.14.87-.35 1.33-.58zm-4.8 1.82l-9-17.51h-1.71l9.25 17.94c.42-.15.92-.28\n       1.46-.43zm-5.21.81l-9.54-18.52-1.74-.09 9.53 18.5zm-5.81-.36l-9.53-18.5-1.75-.12 9.54\n       18.51zm25.84-16l-7.7-14.93c-.3.47-.64.93-1 1.38l8 15.55c.27-.66.49-1.33.7-2zm2.11-7.04l-7.61-14.71v.07a12.69\n       12.69 0 00-.65 1.89l7.67 14.89c.18-.733.377-1.447.59-2.14zm2.07-6.89l-6.73-13.05c-.333.467-.667.94-1 1.42l7\n       13.59c.25-.68.49-1.33.73-1.96zm1.83-7.37l-4.29-8.33a6.06 6.06 0 00-1.55.28l5.47\n       10.6.37-2.55zm-58.89-28.94c-7.87-2-16.05 4.56-18.16 12.46-2.11 7.9.52 16.27 4.43 23.42 1.27 2.89 3.93 4.91 5\n       7.6.64 1.44 0 2.74-.25 4.17a11.62 11.62 0 00.35 5 2 2 0 00.33.78c.2.21.457.357.74.42 3.16 1.14 6.32 3.15\n       9.81 3.21a5.66 5.66 0 003.56-1.08c1-.89 1.5-2.27 2.36-3.24 2.22-2.83.08-5.24-1.48-7.81-1.92-3.46.07-4.37\n       2.72-6.08 2-1.29 4.19-2 5.46-4.2a9.77 9.77 0 00.88-7.82c-.65-1.94-1.88-4.22-.86-6 .51-.88 1.46-1.51\n       1.47-2.38a1.86 1.86 0 00-1.57-1.69 5.37 5.37 0 00-2.44.16 30.08 30.08 0 00-12.68-14.85",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M199.12 15.17a29.93 29.93 0 0112.57 14.89 5.72 5.72 0 012.44-.16 2 2 0 011.56 1.69c0 1-.93 1.62-1.47\n       2.38-1 1.76.19 3.93.86 6a10 10 0 01-4.72 11.58c-1.85 1-4.2 1.5-5.07 3.35-.75.5 1.83 4.93 2.41 5.33",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M179.07 52.5a15.43 15.43 0 01-7-5.7 9.93 9.93 0 01-1-8.81 8.49 8.49 0 00.83-2.46 7.44 7.44 0\n       00-1.08-3.08 9.13 9.13 0 012.24-10.17 94.28 94.28 0 0110.63-7.57 73.75 73.75 0 009.5-7.26 30.78 30.78 0\n       003.37-3.64s1.83 3.11 2 3.31c.43 1.13 1.27 2.89 1.21 4a13.6 13.6 0 01-4.58 7.94c-2.06 2-4.44 4.3-4 7 .33\n       2.15 2.45 3.57 3.68 5.35a8.28 8.28 0 01-.18 9.5c-1.74-1.4-3.75-2.85-5.83-2.29a3.509 3.509 0 101.61 6.83 4 4\n       0 001.82-1.11 27.45 27.45 0 012 7.42c0 .61.11 1.34-.44 1.61-.87.48-2-.46-2.52.8-.17.29 0 .87-.18 1.17a8.05\n       8.05 0 01-.61 1.9c-.05.26-.22.56-.28.82a1.05 1.05 0 01-.78.33 1.2 1.2 0\n       01-.62-.46c-.71-.8-.9-1.5-1.81-2.12a12.85 12.85 0 00-2.76-1.5c-1.42-.59-3.29-1.09-5.22-1.81z",
            fill: "#000",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M192.57 15.45c.53.7 1.39-1.06 1.6-1.53a7.71 7.71 0 001-1.69c.23-.73-.26-1.32-.8-.72-.54.6-2.46\n       2.94-1.8 3.94zm-7.22 20.2a.44.44 0 00.34-.59 3.75 3.75 0\n       00-1.06-2.08c-.18-.2-.53-.11-.73.07-.2.18-.11.53.07.73.35.41.606.891.75 1.41 0 .38.16.58.62.46h.01zm-3.2\n       3.34c.12 0 .23-.06.2-.18.2-.18.11-.53-.07-.73a12.1 12.1 0 01-2.11-2.29.497.497 0 00-.87.48v.12a8.38 8.38 0\n       002.25 2.38c.25.32.4.4.6.22z",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M205.5 25.51a8.61 8.61 0 00-4.62.37",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M213.21 36.62a6.31 6.31 0 01-7 .65m1.23-7.31a2.05 2.05 0 00-1.75-.41 1.75 1.75 0 00-1.29 1.22",
            stroke: "#000",
            "stroke-width": "1.2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M189.31 42.04c0-.38 1.48-.52 2.94-.17",
            stroke: "#000",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M202.56 65.45a9.8 9.8 0 003.27.27 3.32 3.32 0 002.62-1.77c.21-.48.4-1.15.93-1.16.229.02.446.11.62.26 0\n       .14 1 .71 1.17.81l1.26.87a20.08 20.08 0 012.26 1.93c.346.34.663.709.95 1.1l5.05 6.41a14.51 14.51 0 011.77\n       3.68c1.08 2.54 2.9 4.67 4.49 6.92a42.806 42.806 0 012.2 3.43 44.53 44.53 0 016 23.27 22.94 22.94 0 01-1.52\n       8.36c-3.89-.72-7.89 0-11.85 0 1.69-6.41 0-14.21-1.7-20.61-.43-1.59-.85-3.18-1.41-4.73a49.13 49.13 0\n       00-2.28-5.04 162.08 162.08 0 00-11.6-19.84 37.36 37.36 0 00-3.33-3.73c-.13-.14-.26-.33-.19-.51s1.05.08\n       1.29.08z",
            fill: "#FAFAFA",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M203.69 161.54c-2.53 2.53-35 12.91-35 12.91-.87-3-1.79-5.89-2.48-8.89a1.07 1.07 0 01.45-1.37c2.94-2.36\n       6.79-3.54 10.17-5.26 3.38-1.72 6.48-3.36 9.63-5.19a13.09 13.09 0 003.35-2.51c.84-1 .79-2.56\n       1-3.81.47-2.33.88-4.68 1.28-7 .373-2.187.74-4.373 1.1-6.56.09-.53-.08-4.4.45-4.4 2 0 2.73.09 4 0 .9 2.38\n       4.13 5.66 6.08 7.28a9.86 9.86 0 007 2.36 2.6 2.6 0 011.34.08c1.99.88-6.37 20.42-8.37 22.36z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#929294",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M156.55 166.98c-.57.45 2.23 15.69 3.7 18 1.47 2.31 2.53-9.8 2.78-10.18l.34-.06a48.57 48.57 0\n       01-2.56-8.77 23.05 23.05 0 00-4.26 1.01h0z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#000",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M165.69 164.77s-3 .89-5 1.24a54.43 54.43 0 002.87 9.83 22.38 22.38 0 003.5-.83 17.77 17.77 0\n       002.12-.74l-3.49-9.5z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M214.74 119.4s18.91-5.75 20.86-5.34c1.67.5 36.54 19.38 36.17 20.16-.37.78-2 10.12-3.24\n       9.14-1.24-.98-30.39-9.91-32.24-10.05-1.76.2-25.41 7.39-28.38 6.61-2.69-.86-6.47-5.37-6.47-5.37a23 23 0\n       01-3.75-5.1",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#929294",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M275.45 134.56l-3.81-.88-2.77 9.68s1.87.72 3.87 1.44l2.95-10.43a1.08 1.08 0 01-.24.19z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M275.32 134.8l-2.59 10a29.38 29.38 0 004.49 1.65c.77 0 4.95-14.33 4.55-17.14-.36-2.63-5.34 4.28-6.45\n       5.49z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#000",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M234.69 118.04l.06.07c.37.35 1.17-.28 1.54-.45a37.92 37.92 0 001.8-.91 23.53 23.53 0 003-2 17 17 0\n       004-4.28 14.37 14.37 0 002.19-8.25 14.56 14.56 0\n       00-.89-4.63l-.06-.15c-9.42-.82-21.29-14.75-21.29-14.75a53.11 53.11 0 018.65 15.76c1.69 5.32 3 8 1.25\n       15.53a19 19 0 00-.19 2.16c-.06.45-.37 1.46-.06 1.9z",
            fill: "#ED1D24",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M131.61 163.84l-28.05-38.85a3 3 0 01.75-4.35l24.34-17.74a3 3 0 014.35.75l28.04 38.8a3 3 0 01-.75\n       4.35l-24.69 17.53a2.58 2.58 0 01-3.99-.49h0z",
            stroke: "#000",
            fill: "#034694",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M120.17 133.45a.4.4 0 00.59.07l.34-.23-.22-.13c-.3-.18-.46-.27-.65-.14a.28.28 0\n       00-.06.43m.08.46c.1-.11.19-.17.17-.2a.51.51 0 01-.5-.25.46.46 0 01.09-.68c.3-.2.68.12.94.28.26.16.26.18.48\n       0a.31.31 0 00.12-.47c-.22-.33-.46 0-.61-.21a.14.14 0 010-.21c.23-.15.54.15.72.42.18.27.25.5 0\n       .64l-.75.49c-.2.13-.41.26-.48.46l-.18-.27zm1 .63l1-.67a.63.63 0\n       00.42.27l-.27-.37.48-.32-.23-.2-.43.26-.11-.16-.16.11.11.16-1.05.7c-.21.14-.3.32-.15.55a.53.53 0\n       00.33.21l.16-.08a.49.49 0 01-.22-.16c-.09-.14 0-.22.1-.29m-3.72-.19l1-.67a.63.63 0\n       00.42.27l-.27-.37.48-.32-.23-.2-.43.26-.11-.16-.16.11.11.16-1.05.7c-.21.14-.3.32-.15.55a.53.53 0\n       00.33.21l.16-.08a.49.49 0 01-.22-.16c-.09-.14 0-.22.1-.29m2.13-5.44a1.25 1.25 0 00-.21-.88 1 1 0 00-1.5-.22\n       1.08 1.08 0 00-.4 1.65c.06.085.127.166.2.24a1.43 1.43 0 00.37-.2l.17-.11a1.59 1.59 0 00.32-.25c.05-.06 0-.12\n       0-.24l.34.51-.78.52a2.47 2.47 0 00-.28.22 6.17 6.17 0 01-.55-.71 1.24 1.24 0 01.27-1.93 1.43 1.43 0\n       012.11.59c.12.17.21.37.31.55l-.37.24m-.54 1.05c.24-.16.48-.31.49-.45l.21.28c0 .06-.15.14-.13.18.02.04.29 0\n       .43.2s.08.22 0 .28a.13.13 0 01-.19 0l-.14-.23c-.12-.17-.25-.12-.4 0l-.7.46a.86.86 0\n       00-.33.31l-.25-.38a.86.86 0 00.41-.18l.6-.4m1.14 1.42c.11.17.17.26.3.18a.31.31 0\n       00.08-.44c-.15-.22-.42-.18-.62-.1l.24.36m-.36-.32l-.2.11a.64.64 0\n       00-.28.92c.1.16.257.275.44.32-.18.12-.54-.06-.71-.32a.86.86 0 01.37-1.21.88.88 0 011.3.19.58.58 0\n       01-.08.82c-.16.1-.23\n       0-.38-.23l-.46-.6zm-5.44-.96l.28.42c.133.226.342.396.59.48l-.35.14c-.07-.09-.16-.2-.24-.32l-.67-1a1 1 0\n       00.5-.21l1.28-.85a1 1 0 00.39-.37l.81 1.23-.25.19a1 1 0 00-.22-.6l-.23-.34-.81.54c.18.27.38.57.58.82-.27\n       0-.55-.41-.69-.62l-.06-.09-.91.6m1.17 1.75a.4.4 0 00.59.07l.34-.23-.22-.13c-.3-.18-.45-.27-.65-.14a.28.28 0\n       00-.06.43m.08.46c.1-.11.19-.17.17-.2a.51.51 0 01-.51-.25.46.46 0 01.09-.68c.3-.2.68.12.94.28.26.16.26.18.48\n       0a.31.31 0 00.12-.47c-.22-.33-.46 0-.61-.21a.14.14 0 010-.21c.23-.15.54.15.72.42.18.27.25.5 0\n       .64l-.75.49c-.2.13-.41.26-.48.46l-.17-.27zm1.51 1.29a.66.66 0 01-.9-.3 1.29 1.29 0\n       01-.18-.44v-.11l.26-.15a.54.54 0 000 .61.33.33 0 00.51.14c.41-.27-.11-.92.39-1.25.26-.17.5 0\n       .72.29.07.11.126.227.17.35v.07l-.24.15a.47.47 0 000-.5c-.09-.14-.23-.22-.38-.12-.4.27.12 1-.35 1.28m1.87\n       1.4c.11.17.17.26.3.18a.31.31 0 00.08-.44c-.15-.22-.42-.18-.62-.1l.24.36m-.35-.31l-.2.11a.64.64 0\n       00-.28.92c.1.16.257.275.44.32-.18.12-.54-.06-.71-.32a.86.86 0 01.37-1.21.88.88 0 011.3.19.58.58 0\n       01-.08.82c-.16.1-.23 0-.38-.23l-.46-.6zm.84 1.29c.24-.16.48-.31.49-.45l.21.28c0 .06-.15.14-.13.18.02.04.29 0\n       .43.2s.08.22 0 .28a.13.13 0 01-.19 0l-.14-.23c-.12-.17-.25-.12-.4 0l-.7.46a.86.86 0\n       00-.33.31l-.25-.38a.87.87 0 00.41-.18l.6-.4m1.42.85l-.12.08s-.06 0 0 .06c.2.048.38.16.51.32a.46.46 0\n       01-.16.72l-.76.5a.93.93 0 00-.33.3l-.21-.31.93-.62c.22-.14.43-.33.25-.61-.18-.28-.46-.17-.69\n       0l-.55.36a.84.84 0 00-.33.31l-.25-.38a.84.84 0 00.41-.18l.81-.54c.14-.09.27-.18.29-.3l.24.31",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M114.07 129.05c-.06.12-.15.34-.3.35-.15.01-.26-.28-.38-.51a2.47 2.47 0 00-.28-.41.25.25 0\n       010-.25.28.28 0 01.15-.16c.09-.05 0 0 .19-.28a.91.91 0 00.18-.52c0-.1 0-.1.05-.11.05-.01.1 0 .21-.18a1 1 0\n       00.13-.26 1.8 1.8 0 01-.48-.32 2.78 2.78 0 00-.34.31 1.32 1.32 0 00-.35.5s.16.13.22.22 0\n       .24-.15.38-.21.13-.27 0c-.06-.13-.34-.53-.44-.71-.1-.18-.05-.17 0-.27s.14-.14.19-.18a3.86 3.86 0\n       00.27-.5v-.21c0-.08.1-.09.15-.11a.52.52 0 00.14-.1l-.17-.25a1.85 1.85 0 01-.14-.25 1.1 1.1 0\n       01-.37-.18c-.17-.13-.34-.3-.39-.33-.05-.03-.09 0-.21.19a1 1 0 00-.17.31l.13.1a.28.28 0 01.13.21.65.65 0\n       01-.28.38c-.11.06-.16-.1-.38-.44a4.27 4.27 0 01-.28-.44.19.19 0 01.07-.17s.07 0\n       .21-.26c.14-.26.18-.25.18-.38v-.19c0-.06.22 0 .35.05a.45.45 0 00.29 0l-.08-.11a1 1 0 01-.52-.32 2.27 2.27 0\n       00-.7-.55 1.55 1.55 0 00-.5.05l.15.11c.1.08.08.12 0 .31s-.26.25-.37.09c-.11-.16\n       0-.16-.26-.45-.26-.29-.29-.3-.26-.41.03-.11.12-.13.19-.17.07-.04.15 0 .26 0l.43-.06a1.26 1.26 0\n       00.42-.12.24.24 0 01.25.11c.1.19.31.19.45.2a3 3 0 00.33 0 1.43 1.43 0 01-.58-.72.6.6 0\n       01.5-.85c.329.039.628.208.83.47.27.31.4.52.5.5.1-.02.12-.18.31-.24a.72.72 0 01.43 0 .28.28 0 00.25\n       0s-.26.51-.58.54c-.55.05-.86-.47-1.12-.71-.26-.24-.6-.36-.77-.24-.33.23 0 .94.39 1a1.58 1.58 0\n       011.34.78c.45.6.47.8 1.11 1l.2.07a1.16 1.16 0 01.38-.21c.27-.1.57-.1.58-.13.01-.03-.17 0-.14-.1a1.34 1.34 0\n       01.68-.1c.231.046.45.142.64.28.06 0-.1-.17 0-.17s.29.1.55.51c.26.41.14.39.21.57.07.18.14.33.16.43.02.1 0 .18\n       0 .24s0 .08.12.26.1.28.06.32a.88.88 0 01-.33.17.22.22 0 01-.2-.07.85.85 0\n       01-.2-.34c-.09-.24-.13-.31-.36-.16-.23.15-.18.19 0 .44s.32.24.34.28c.02.04 0\n       .08-.11.13s-.17.1-.24.08c-.07-.02-.11-.18-.11-.18a.75.75 0 01-.12.22.86.86 0\n       01-.91.21c0-.08.27-.27.16-.31-.11-.04-.21.14-.44.14l-.18.16a7.35 7.35 0 00-.85.85 1.7 1.7 0 00-.41.72c0\n       .06.09.1.2.19.11.09.12.13.06.25m2.65-4.53a.29.29 0 01.07.25.23.23 0 000-.3.24.24 0 00-.42 0 .28.28 0 000\n       .31.85.85 0 00-.26.27 1.71 1.71 0 00-.1.32 1.81 1.81 0 01.23-.35 2.39 2.39 0 01.25-.19s-.09-.18\n       0-.28c.09-.1.11-.09.2-.02l.03-.01zm-2.53 1.3a.57.57 0 000 .55.87.87 0 01.15-.68 1.76 1.76 0\n       01.21-.25c0-.08-.35.11-.38.06-.03-.05 0-.23.17-.51.138-.15.3-.275.48-.37a1.12 1.12 0 00-.62.44.92.92 0\n       00-.16.56c.05.07.27-.14.29-.05a1.05 1.05 0 00-.14.26v-.01zm.35.78c0 .13 0 .47.15.39-.12.05-.1-.32\n       0-.47.1-.15.19-.23.17-.29-.02-.06-.19-.07-.4.07.19 0 .28 0 .23.05a1.54 1.54 0\n       00-.15.26v-.01zm2.68-1.07h.11a.47.47 0 000-.19.54.54 0 00-.19-.18.57.57 0 01.12.19.32.32 0\n       01-.04.19v-.01zm.07.85a.21.21 0 00.2 0l.11-.07h.05a.08.08 0 00.1\n       0l-.07-.1c-.07-.1-.12-.16-.12-.1v.17l-.12.09a.52.52 0\n       01-.15.02v-.01zm-1.35-.83s-.33.23.2.6c.16.1.294.238.39.4 0 0 0-.16-.33-.42s-.26-.57-.26-.57v-.01z",
            fill: "#EC1C24",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M116.76 126.14a.37.37 0 01.29.09c.1.11.13.26.24.35a.8.8 0 00.14.09.62.62 0 01-.26 0c-.14\n       0-.19-.14-.26-.35a.36.36 0 00-.14-.18",
            fill: "#EC1C24",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            stroke: "#FFF",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M143.4\n       152.3l-3.29 2.36m14.73-10.55l-7.4 5.3m-17.5-40.94l4.23 6.08",
          },
        }),
        _c("path", {
          attrs: {
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M142.57\n       116.91l5.32-3.61 9.83 13.62-5.32 3.61z",
          },
        }),
        _c("path", {
          attrs: {
            d: "M189.56 129.45c-.55-.39-.49-1.21-.36-1.87.75-3.88 1.24-7.38 2.35-11.16a39.7 39.7 0 001.35-12.43 19.38\n       19.38 0 00-.38-3.76 20.78 20.78 0 00-2-4.76 19.38 19.38 0 00-4.21-6.08c-6.4-5.48-11.93 3-15.19 7.79-2.71\n       4-5.92 9-7.11 13.77a2.88 2.88 0 01-4.09 1.64c-1.58-.6-4.15-1-5.43-2.08-1.56-1.29 0-4.6.42-6.29a42 42 0\n       016.78-14.48c2.06-2.7 3.32-5.78 5.38-8.54a89.34 89.34 0 0110.2-10.75c3-2.86 5.24-5.35\n       9.28-6.55l2.87-6.14s30.71 13.93 33.17 56.53c.35 6.14-4.42 10.4-9.37 13.14-6.84 3.79-15.19 3-22.79 2.32a1.76\n       1.76 0 01-.87-.3z",
            fill: "#ED1D24",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M187.02 82.96c-.46.207-.913.423-1.36.65a31.23 31.23 0 00-4.34 2.69l-.3.23.32-.15 1.36-.64 3.18-1.48\n       1.36-.64 3.27-1.53 1.36-.64.79-.37-.85.21c-.493.12-.977.253-1.45.4a28.41 28.41 0 00-3.34\n       1.27zm16.06-15.03l18.9 50.67a10.3 10.3 0 00.6-4.34c-.11-1.86-.29-3.64-.5-5.39l-12.31-33a63.53 63.53 0\n       00-6.69-7.94zm-7.96-6.75l23.32 62.52a14.88 14.88 0 002.64-3.22l-20.49-54.93a58.79 58.79 0\n       00-5.47-4.37zm18.57 20.93l7.06 18.92a70.2 70.2 0 00-7.06-18.92zm-6.12-22.1l2.94\n       3.53-1.27-3.39zm-18.16-2.27l-.51 1.09 19.28 51.62.13.14a2.6 2.6 0 01.35 1.13l5.61 15a26.93 26.93 0\n       003-2l-24.25-65a33.55 33.55 0 00-3.61-1.98z",
          },
        }),
        _c("path", {
          attrs: {
            d: "M190.39 81.69l-6.14-16.46c-.89.38-2.15.89-3.42 1.58l6.19 16.14a28.41 28.41 0 013.37-1.26zm50\n       13.87l5.23 14a14.33 14.33 0 001.62-5.67l-2.5-6.7a18.81 18.81 0 01-4.35-1.63zm-7.3-4.98l8.79 23.56a16.88\n       16.88 0 002.73-3l-6.25-16.69a46.58 46.58 0 01-5.27-3.87zm1.66 25.56c-.05.45-.37 1.45-.06 1.89l.06.07c.34.32\n       1-.16 1.42-.38l-1.26-3.38c-.04.61-.09 1.21-.16 1.8zm-46.97 12.08l2.37 6.36c1-.17 2.27-.39\n       3.6-.66l-4.53-12.13c-.39 1.86-.92 4.21-1.44 6.43z",
          },
        }),
        _c("path", {
          attrs: {
            d: "M238.36 94.45l6.25\n       16.76c.16-.22.33-.44.47-.67.14-.23.37-.61.54-.92l-5.23-14-2.03-1.17zm-7.67-5.95l9.93\n       26.61.47-.33c.27-.21.52-.43.77-.64l-8.79-23.56c-.82-.7-1.62-1.4-2.38-2.08zm4.25 25.48v.37l1.26\n       3.38.12-.06c.41-.19.82-.41 1.22-.62l-2.51-6.73c0 1.22-.01 2.44-.09 3.66zm-21.25-31.87a64.94 64.94 0\n       00-3.92-6.23l12.31 33a77.282 77.282 0 00-1.33-7.85l-7.06-18.92zm-13.1-16.56l20.49 54.9a11.23 11.23 0\n       00.9-1.88l-18.9-50.67a87.08 87.08 0 00-2.49-2.35zm-7.61-5.8l24.25 65c.42-.34.823-.673\n       1.21-1l-23.32-62.57c-.78-.55-1.49-1.02-2.14-1.43zm19.96 67.8c.447-.247.887-.497\n       1.32-.75l-3.1-8.31-22.26-59.66-.86 1.85 19.73 53 1.53 4.09c.53 1.48 1.11 3.08 1.33 3.56l2.31 6.22zm-3.25\n       1.58l-24.21-64.9a1.71 1.71 0 00-1.17 1.22l24 64.26 1.38-.58zm36.7-31.51l-.06-.15a11.83 11.83 0\n       01-1.59-.26l2.5 6.7a14.83 14.83 0 000-1.66 14.56 14.56 0 00-.85-4.63z",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M213.37 88.65a1.23 1.23 0 00-.4 0 1.37 1.37 0 00-.54.24.94.94 0 00-.3.28.5.5 0 01-.13.13.55.55 0\n       00-.16.17 1.58 1.58 0 00.16 1.59 1.53 1.53 0 001.3.71h.37a2.38 2.38 0 00.37-.17 1 1 0 00.41-.4 1.46 1.46 0\n       00.26-1 1.92 1.92 0 00-.26-.83l-.09-.11a1.57 1.57 0 00-.99-.61zm2.94 7.15a1.23 1.23 0 00-.4 0 1.37 1.37 0\n       00-.54.24.94.94 0 00-.3.28.5.5 0 01-.13.13.55.55 0 00-.16.17 1.58 1.58 0 00.16 1.59 1.53 1.53 0\n       001.3.71h.37a2.38 2.38 0 00.37-.17 1 1 0 00.41-.4 1.46 1.46 0 00.26-1 1.92 1.92 0 00-.26-.83l-.09-.11a1.57\n       1.57 0 00-.99-.61z",
            fill: "#000",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M155.05 102.14a2.06 2.06 0 00.12 1c.11.28.21.57.31.85l.78 2.11 1.61 4.35.45 1.21c0\n       .06.11.44.17.46l1.44.55a3 3 0 00.43.16l-4.67-12.65c.1.27-.41.94-.49 1.21a3.83 3.83 0\n       00-.15.75zm2.64-6.69l6.06 16.16a2.35 2.35 0 00.26-.62c.17-.44.36-.92.57-1.43l-5.89-15.76c-.33.54-.66 1.09-1\n       1.65zm3.74-4.94l5.26 14.39c.29-.59.6-1.19.93-1.81l-5.15-14.06c-.34.48-.69.97-1.04 1.48zm3.38-5.27l5.15\n       13.8c.327-.52.66-1.043 1-1.57l-5-13.33c-.32.43-.78.64-1.15 1.1zm3.47-5.01l5.16 13.84c.353-.453.72-.903\n       1.1-1.35l-5.24-14c-.38.34-.61 1.1-1.02 1.51zm3.66-4.62l5.34 14.16c.387-.38.78-.753\n       1.18-1.12l-5.35-14.34c-.42.34-.76.94-1.17 1.3zm17.75 46.84l2.06 6.46c.48-.1 1.43.65\n       1.94.54l-3-9c-.09.63-.75.79-1 2zm-7.1-37l-5.56-15c-.41.29-.77.75-1.2 1.07l5.5 14.75c.413-.287.833-.56\n       1.26-.82zm10.22 28.1c-.3.12-.52.78-.61 1-.33 1 .49 2.2.83 3.12l1.3 3.49 2.24 6c.19.51.36 1 .55 1.53.24.66\n       1.6 1.82 1.76.56.08-.57-.48-1.48-.68-2l-.86-2.31-2.39-6.41-1.34-3.59c-.09-.25-.34-1.38-.69-1.42a.25.25 0\n       00-.11.03zm-11.27-45.19c-1.13-1.75-1.31-.8-1.77-.53l22.92 61.62c.48-.15 1.52 1.16 2 1l-23.15-62.09z",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M201.29 110.35s7.64 3 12.7-7.34",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M152.43 111.62l-4 8.89s-.68 1.64.68 1.94c1.36.3 1.71-.34 1.71-.34a2.23 2.23 0 00.35 1.89c.67.71\n       2.07-.36 2.07-.36s-.2.7.94 1.52a1.6 1.6 0 002.11-.26s-.3.93 1.24 1.65c1.54.72 2.47-1.33 2.47-1.33l.6-1.67\n       1-2.31c5.78 5 7.57 2.18 7.65 1.34.08-.84-3-1.09-3.83-3a17.22 17.22 0 00-3.43-4.13l-9.56-3.83z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M162.59 115.07a1.45 1.45 0 01-1.84.91l-7.41-2.53a1.45 1.45 0 01-.91-1.84l.38-1.12 9.13 2.93.65 1.65z",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M199.01 64.18c2.63.75 10.13 2 10.47-1.94m-45.45 48.74a2.88 2.88 0 01-4.09\n       1.64c-2.06-1-4.31-1.84-6.44-2.72.92-3.13 1-6.46 2.11-9.54a32.29 32.29 0 014.27-7.53l7.81-11.38c3-4.27 6-8.62\n       9.9-12.08a32.65 32.65 0 015-4c.55-.31 3.64-1 3.88-1.56l1.29-2.77c.88-1.9 1-3.74 3.39-2.42.72.4 1.42.84 2.11\n       1.28a56.26 56.26 0 015.86 4.36 63.68 63.68 0 0114.05 17 73.79 73.79 0 019.11 29.95 94.8 94.8 0 01.23\n       3c.055.828.018 1.66-.11 2.48-.76 4.61-4.4 7.9-8.25 10.16a19.15 19.15 0 01-9.85 3c-3.167\n       0-6.333-.113-9.5-.34-2.12-.13-5.85.54-5.86-2.06-.01-2.6 1.61-6.11 2.29-8.73.75-2.91 1.47-5.82\n       2-8.78.83-4.71-.56-10.84-2.89-15-1.65-2.95-4.89-6.83-8.3-7.81-3.13-.9-6.9 4.66-8.64 6.86a65.66 65.66 0\n       00-9.37 16.99h0zM181.17 87s2-1 5.64-3.18",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M252.69 32.22c-.16-1.76-1-3.32-1.26-5a44.73 44.73 0 00-.8-6.09 2.38 2.38 0 01-.14-.86 1.29 1.29 0\n       011.2-1.09 1.64 1.64 0 011.42 1l-.27-.13a.64.64 0 01.1.48",
            fill: "#FFF",
            "fill-rule": "nonzero",
          },
        }),
        _c("path", {
          attrs: {
            d: "M252.38 29.5a3 3 0 01-.82-1.72c-.24-1.59-.33-3.19-.54-4.78-.17-1.29-.82-2.28.24-3.3a3.11 3.11 0\n       001-2.45 82.34 82.34 0 011.51-8.1c.11-.47.12-1.17.65-1.37a1.21 1.21 0 011.39.76 8 8 0 01.1 2.61c0 .87.05\n       1.75.07 2.62.02.87 0 1.56.06 2.32v-.27c.48-.41 1.13-.86 1.77-.5.32.18.47.87.67 1 .64.29 1.23-.54\n       1.91-.22.3.14.37.45.62.63s.74.16 1.18.27a2.82 2.82 0 011.9 1.83c.42 1.25-.41 3.07-.83 4.25-.8 2.23-1.66\n       4.78-3.3 6.57a7.51 7.51 0 01-.68.65 4.62 4.62 0 01-.67.48m.08-.06a4.06 4.06 0 01-1.9.55",
            stroke: "#000",
            "stroke-width": "1.2",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M256.09 16.07c-.27 3.47-.18 3.17-.34 4.47-.07.57 0 1.27.46 1.53a2 2 0 001.92-.37 4.54 4.54 0\n       00.88-1.19l.75-1.3a3.63 3.63 0 00-.5 1.43c-.05.43 0 1 .46 1.09.46.09.7-.19.94-.47a7.91 7.91 0 001-1.46 2.42\n       2.42 0 000 1.49.87.87 0 00.28.44.73.73 0 00.9-.14c.22-.25.377-.548.46-.87m-12.07-1.05a1.63 1.63 0 012\n       .63c.91 1.06.81 2.62 1.72 3.67.45.52 1.33.87 1.2 1.54",
            stroke: "#000",
            "stroke-width": "1.2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M250.69 33.55l.37-2.34c.08-.49.41-.85.74-.79l7 1.11c.33.05.54.49.46 1l-.33 2.09",
            stroke: "#000",
            "stroke-width": "1.5",
            fill: "#FFF",
            "fill-rule": "nonzero",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M234.35 118.92c17.3-7.12 12-21.46 12-21.46-9.42-.82-21.29-14.75-21.29-14.75m-93.45\n       81.13l-28.05-38.85a3 3 0 01.75-4.35l24.34-17.74a3 3 0 014.35.75l28.04 38.8a3 3 0 01-.75 4.35l-24.69\n       17.53a2.58 2.58 0 01-3.99-.49h0zm-71.93-24.85h13.65m-4.55-28.67h17.26M97.9 94.39H87.38m66.68\n       97.65v10.42m5.41 3.84v-7.69m122.34-89.69v10.42m5.41 3.85v-7.69m-79.65-55.49c2.733.233 5.467.443 8.2.63\n       5.34.36 10.72.74 16.08.64 1.37 0 3.3.26 4.47-.65 1.35-1.06 2.36-3.42 3.24-4.88a63.07 63.07 0\n       005.71-11.16c1.27-3.57 3.41-6.92 4.45-10.57.07-.24.17-.53.42-.57a.66.66 0 01.25 0c1.1.24 2.2.52 3.31.7\n       1.11.18 4.56.27 5.24 1.14.55.71-.67 3-.78 3.89-.34 2.52-1.32 4.92-1.7 7.47a70.08 70.08 0 01-3.41 12.64c-1.36\n       3.92-2.26 8.16-4.36 11.72-4.3 7.37-15.79 8.61-15.79 8.61l-9.5-.58",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M208.01 60.58s11.29 7.81 15.39 18.46c4.1 10.65 17.2 19.25 10.65 40.14m34.33-113.5a12.51 12.51 0 013.9\n       1c1.1.59 1.37 1.49.36 2.09a27.34 27.34 0 01-11.14 2.81m-15.54-4.13a5.72 5.72 0 01-2.36-1.65 1.53 1.53 0\n       01.52-2.3 12.39 12.39 0 015.41-1.79",
            stroke: "#000",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M201.35 55.57c.85.21 1.94.3 2.29.45a6.86 6.86 0 013.21 2.72 2.53 2.53 0\n       000-.62c0-.13-.35-.39-.43-.55-.26-.56-.32-1.2-.53-1.77a2 2 0 01.45-2.37c.1-.13.21-.29.15-.45a40.15 40.15 0\n       00-5.92 1.59c-.17.06-.37.16-.36.34.01.18.54.54 1.14.66z",
            fill: "#000",
            "fill-rule": "nonzero",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }